import React, { useState, useEffect } from 'react';
import { MessageSquare, ArrowUp, X, Send, Calendar } from 'lucide-react';

export default function FloatingWidget() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleEnquiry = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => {
      setIsDrawerOpen(false);
      setFormSubmitted(false);
      e.target.reset();
    }, 2000);
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3">


      {/* Quick Enquiry Float Trigger */}
      <button
        onClick={() => setIsDrawerOpen(true)}
        className="bg-primary hover:bg-primary-dark text-white p-3.5 rounded-full shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center justify-center border border-white/10"
        title="Quick Enquiry"
      >
        <MessageSquare className="h-6 w-6 animate-pulse" />
      </button>

      {/* Quick Enquiry Drawer Modal */}
      {isDrawerOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="bg-navy-light w-full max-w-md rounded-3xl overflow-hidden border border-white/10 shadow-2xl animate-fade-in text-white relative">
            <button
              onClick={() => setIsDrawerOpen(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-white p-1 rounded-lg"
            >
              <X className="h-6 w-6" />
            </button>
            <div className="bg-gradient-to-r from-primary to-primary-light px-6 py-6">
              <div className="flex items-center space-x-3">
                <Calendar className="h-6 w-6 text-golden" />
                <h3 className="font-montserrat font-bold text-lg text-white">Quick Banking Enquiry</h3>
              </div>
              <p className="text-xs text-gray-200 mt-1">Leave your details and our branch representative will contact you.</p>
            </div>

            <form onSubmit={handleEnquiry} className="p-6 space-y-4">
              {formSubmitted ? (
                <div className="py-8 text-center space-y-3">
                  <div className="mx-auto h-12 w-12 rounded-full bg-emerald/20 flex items-center justify-center text-emerald">
                    ✓
                  </div>
                  <h4 className="text-lg font-semibold text-white">Enquiry Submitted!</h4>
                  <p className="text-sm text-gray-400">Our support representative will call you back shortly.</p>
                </div>
              ) : (
                <>
                  <div>
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Full Name</label>
                    <input
                      type="text"
                      required
                      placeholder="Enter your name"
                      className="w-full bg-navy border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-golden transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Mobile Number</label>
                    <input
                      type="tel"
                      required
                      pattern="[0-9]{10}"
                      placeholder="10-digit mobile number"
                      className="w-full bg-navy border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-golden transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Product of Interest</label>
                    <select
                      required
                      className="w-full bg-navy border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-golden transition-colors"
                    >
                      <option value="">Select Service / Scheme</option>
                      <option value="savings">Savings Account Opening</option>
                      <option value="fd">Fixed Deposit Schemes</option>
                      <option value="loans">Gold / Personal / Home Loan</option>
                      <option value="business">MSME / Business Loan</option>
                      <option value="digital">Mobile / Internet Banking Support</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Message</label>
                    <textarea
                      rows="3"
                      placeholder="How can we help you?"
                      className="w-full bg-navy border border-white/10 rounded-xl px-4 py-2 text-sm text-white focus:outline-none focus:border-golden transition-colors"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-gradient-to-r from-golden to-golden-dark text-navy font-bold rounded-xl hover:opacity-95 transition-opacity flex items-center justify-center space-x-2 shadow-lg shadow-golden/10"
                  >
                    <span>Submit Request</span>
                    <Send className="h-4 w-4" />
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
